import formatClearSvg from '@listening/assets/astro/images/format-clear.svg';
import image54Png from '@listening/assets/astro/images/image-54.png';
import speakLineSvg from '@listening/assets/astro/images/speak-line.svg';
import voiceprintLineSvg from '@listening/assets/astro/images/voiceprint-line.svg';

export function ListenToYourHomework() {
  return (
    <section className='flex flex-col items-center gap-8 px-5 py-18 pt-8 pb-[95px] sm:px-14 sm:pt-14 lg:px-18 lg:pt-18'>
      <div className='flex w-full max-w-[1296px] flex-col items-center justify-center gap-18 lg:flex-row lg:gap-0'>
        <div className='flex max-w-[612px] flex-1 flex-col gap-10 lg:gap-8'>
          <h2 className='text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[40px] sm:leading-[47px] lg:text-[44px]'>
            Finally, you can <span className='text-azure-455'>listen</span> to
            homework, instead of read!
          </h2>
          <div className='text-[16px] leading-[24px] text-neutral-945 sm:text-[24px] sm:leading-[36px] lg:text-[20px] lg:leading-[30px]'>
            Do you have all kinds of PDFs you need to listen to? Now, you can
            turn all of these into audio:
          </div>
          <div className='flex flex-[0_auto] flex-col items-start justify-start gap-[24px] p-0'>
            <div className='flex items-start gap-[16px]'>
              <img alt='Voiceprint' loading='lazy' src={voiceprintLineSvg} />
              <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                Digital books & Research papers
              </div>
            </div>
            <div className='flex items-start gap-[16px]'>
              <img alt='Speak' loading='lazy' src={speakLineSvg} />
              <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                Class assignments & PDF handouts
              </div>
            </div>
            <div className='flex items-start gap-[16px]'>
              <img alt='Format Clear' loading='lazy' src={formatClearSvg} />
              <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                Your own writings (essays, thesis, dissertation)
              </div>
            </div>
          </div>
        </div>
        <div className='relative flex-1 self-center lg:self-stretch'>
          <img alt='Girl wearing headphones' loading='eager' src={image54Png} />
          <div className='absolute inset-x-0 bottom-[-85px] flex items-center justify-center lg:bottom-[-37px]' />
        </div>
      </div>
    </section>
  );
}
